import { render } from "./PayStub.vue?vue&type=template&id=46be9e7c"
import script from "./PayStub.vue?vue&type=script&lang=js"
export * from "./PayStub.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__